import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Link, useHistory } from 'react-router-dom'
import { motion } from "framer-motion";

// Material.ui - styles
import { makeStyles, withStyles } from '@material-ui/core/styles'

// Material.ui - core
import {
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Menu,
  MenuItem,
  InputBase,
  Grid,
  Button,
  TextField,
  Box,
} from '@material-ui/core'

// Material ui - lab
import Skeleton from '@material-ui/lab/Skeleton'
import Pagination from '@material-ui/lab/Pagination'

// Material.ui - icons
import { MoreVert } from '@material-ui/icons'
import SearchIcon from '@material-ui/icons/Search'
import { PackageIcon } from "lucide-react";

// moment
import moment from 'moment'
import ModalType from '../../atoms/Modal'
import BasePage from '../../../pages/basePage'
import API from '../../../services/api'
import 'moment/locale/pt-br'
import { useMerchant } from '../../../store/global/useMerchant'
import { useMenu } from '../../../store/global/useMenu';
import { UserRoundCog } from 'lucide-react';
import { CustomerDetailsController } from '../../../services/controllers/customer'
import { SoldPackages } from './SoldPackages';
import { AvailablePackages } from './AvailablePackages';
import { PageTabs } from '../../ui/PageTabs';


moment.locale('pt-br')

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: 280,
    border: '1px solid #d05d02',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  table: {
    minWidth: 300,
    border: '1px solid #ccc',
  },
  pagination: {
    marginTop: '20px',
  },
  filter: {
    margin: '30px 0',
    background: '#fff',
    width: '100%',
    borderRadius: '7px',
    padding: '15px',
    border: '1px solid #d05d02',
  },
  statusSelect: {
    '& div': {
      padding: '8px',
    },
  },
}))

const CustomButton = withStyles(() => ({
  root: {
    color: '#fff',
    border: '0',
    backgroundColor: '#d05d02',
    '&:hover': {
      backgroundColor: '#a74a00',
      border: 0,
      color: '#fff',
    },
  },
}))(Button)

const ITEM_HEIGHT = 48

function Package({
  packages,
  packageSold,
  stateValue,
  getPackage,
  getPackageSold,
  primeiroDia,
  date,
  pagination,
  panel,
  setPackageSold,
  getPackageActive,
}) {
  const CCustomerDetails = CustomerDetailsController();

  const merchant = useMerchant((st) => st.data.merchant);
  const menuSize = useMenu(st => st.data.size)

  const [value, setValue] = useState('0')
  const history = useHistory()
  const { control, watch } = useForm()
  const handleChangeIndex = (event, value) => setValue(value)

  const isClinica = history.location.pathname.split('/').includes('packages')

  const classes = useStyles()

  const [anchorEl, setAnchorEl] = React.useState(null)
  const [open, setOpen] = React.useState(null)
  const [error, setError] = React.useState(null)
  const [openModal, setOpenModal] = React.useState(null)

  const onDecrement = (key) => (event) => {
    setAnchorEl(event.currentTarget)
    setOpen(key)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setOpen(false)
  }

  const ordersExport = async (orderId) => {
    try {
      const result = await API.post(`packages/orders/${orderId}/send-to-vo`)
      setOpenModal(result?.data.message)
      result?.status === 201 && getPackageSold()
      setError(false)
    } catch (err) {
      setOpenModal(err?.response?.data?.friendly_message)
      setError(true)
    }
  }

  const handleOrder = (id) => {
    setAnchorEl(null)
    setOpen(false)
    ordersExport(id)
  }

  const handleCloseActive = (id) => {
    setAnchorEl(null)
    setOpen(false)
    history.push(`/pacotes/vendas?clinica=${isClinica}`, { id })
  }

  const deletePackage = async (orderId) => {
    try {
      const result = await API.delete(`packages/order/${orderId}`)
      setOpenModal(result?.data.message)
      result?.status === 200 && getPackageSold()
      setError(false)
    } catch (err) {
      setOpenModal(err?.response?.data?.friendly_message)
      setError(true)
    }
  }

  const closeModal = () => {
    setOpenModal(false)
  }

  const handleGetPackge = async ({ target }) => {
    getPackage(target.value)
  }

  const handleClick = () => {
    const { dateInicio, dateFim } = watch()
    setPackageSold(null)
    getPackageSold(1, dateInicio, dateFim)
  }

  const handleChangePage = (event, newPage) => {
    setPackageSold(null)
    const { dateInicio, dateFim } = watch()
    getPackageSold(newPage, dateInicio, dateFim)
  }

  const handleActiveCupom = async (active) => {
    await getPackageActive(active)
  }

  const handleUpdateActive = async (active, id) => {
    try {
      const { data } = await API.post(`packages/rule/${id}/status`, {
        active: active !== 'ATIVO',
      })
      setOpenModal(data?.message)
      setError(false)

      setTimeout(() => {
        getPackageActive()
      }, 1500)
    } catch (err) {
      setOpenModal(err?.response?.data?.friendly_message)
      setError(true)
    }
  }

  return (
    <BasePage pageTitle={<><PackageIcon className='w-6 h-6' />Pacotes</>}>
      <ModalType
        open={openModal && true}
        close={closeModal}
        titleDescription={openModal}
        err={error}
        verification={false}
      />
      <motion.div
        initial={{ width: `calc(100vw - 2rem - ${menuSize})` }}
        animate={{ width: `calc(100vw - 2rem - ${menuSize})` }}
        transition={{ duration: 0.3 }}
        className='flex flex-col pt-1.5'>
        <PageTabs
          ariaLabel="Pacotes"
          value={value}
          onChange={(valor) => setValue(valor)}
          style={{
            boxShadow: '0 6px 20px rgb(0 0 0 / 10%)',
            borderRadius: '7px 7px 0 0',
            background: '#fff',
          }}
          tabs={[
            { value: '0', label: 'Pacotes disponíveis' },
            { value: '1', label: 'Pacotes vendidos' },
          ]}
        />

        {parseInt(value, 10) === 0 && (
          <AvailablePackages
            packages={packages}
            onSearch={(texto) => getPackage(texto)}
            onChangeActive={handleActiveCupom}
            onCreate={() => stateValue(1)}
            onSell={handleCloseActive}
            onToggleActive={handleUpdateActive}
          />
        )}

        {parseInt(value, 10) === 1 && (
          <SoldPackages
            packageSold={packageSold}
            pagination={pagination}
            panel={panel}
            primeiroDia={primeiroDia}
            dataFinal={moment(date).format('YYYY-MM-DD')}
            podeIntegrar={!!merchant.hasTokenVarejo}
            onFilter={(pagina, filtros) => {
              setPackageSold(null)
              getPackageSold(pagina, filtros)
            }}
            onPageChange={(pagina, filtros) => {
              setPackageSold(null)
              getPackageSold(pagina, filtros)
            }}
            onSendToErp={handleOrder}
            onDelete={deletePackage}
            onOpenCustomer={(id) => CCustomerDetails.open(id)}
          />
        )}
      </motion.div>
    </BasePage>
  )
}

export default Package
